import React, { Component } from 'react'
import Button from 'react-bootstrap/Button'
import Tooltip from 'react-bootstrap/Tooltip'
import Overlay from 'react-bootstrap/Overlay'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faArrowDown,
  faArrowUp,
  faCheck
} from '@fortawesome/free-solid-svg-icons'
import styles from './NextButtons.css'

class NextButtons extends Component {
  constructor(props) {
    super(props)

    this.state = {
      nextHint: 0,
      nextPageHint: 0,
      exitHint: 0
    }
    this.exitRef = React.createRef()
    this.nextRef = React.createRef()
  }

  componentDidUpdate(prevProps) {
    if (this.props.hasNext && this.performHint('next')) {
      return
    }
    if (this.props.hasNextPage && this.performHint('nextPage')) {
      return
    }
    if (this.props.completed && this.performHint('exit')) {
    }
  }

  performHint(target) {
    if (this.props.hint === undefined) {
      return false
    }
    if (this.props.hint[target]) {
      // Already performed
      return false
    }
    const propName = `${target}Hint`
    const otherPropNames = Object.keys(this.state).filter(
      (name) => name.endsWith('Hint') && name !== propName
    )
    if (otherPropNames.some((name) => this.state[name] !== 0)) {
      return false
    }
    if (this.state[propName] !== 0) {
      return false
    }
    setTimeout(() => {
      const s = {}
      s[propName] = 1
      this.setState(s, () => {
        setTimeout(() => {
          const s2 = {}
          s2[propName] = 2
          this.setState(s2)
        }, 500)
      })
    }, 10)
    return true
  }

  hideHint(target) {
    const s = {}
    s[`${target}Hint`] = 3
    this.setState(s)

    if (!this.props.onHintPerform) {
      return
    }
    this.props.onHintPerform(target)
  }

  nextClicked() {
    if (this.state.nextHint === 2) {
      this.hideHint('next')
    }
    if (!this.props.onNext) {
      return
    }
    this.props.onNext()
  }

  previousClicked() {
    if (!this.props.onPrevious) {
      return
    }
    this.props.onPrevious()
  }

  nextPageClicked() {
    if (this.state.nextPageHint === 2) {
      this.hideHint('nextPage')
    }
    if (!this.props.onNextPage) {
      return
    }
    this.props.onNextPage()
  }

  previousPageClicked() {
    if (!this.props.onPreviousPage) {
      return
    }
    // TODO: 前のページの最初の文ではなく最後の文に移動する。
    this.props.onPreviousPage()
  }

  exitClicked() {
    if (this.state.exitHint === 2) {
      this.hideHint('exit')
    }
    if (!this.props.onExit) {
      return
    }
    this.props.onExit()
  }

  render() {
    return (
      <div className={styles.NextButton}>
        <Button
          disabled={!this.props.hasPrevious && !this.props.hasPreviousPage}
          variant='outline-primary'
          onClick={(event) =>
            this.props.hasPrevious
              ? this.previousClicked(event)
              : this.previousPageClicked(event)
          }
        >
          <FontAwesomeIcon fixedWidth icon={faArrowUp} />
          {this.props.hasPrevious ? '前の文' : '前のページ'}
        </Button>

        <Button
          disabled={!this.props.hasNext && !this.props.hasNextPage}
          ref={this.nextRef}
          variant={!this.props.completed ? 'primary' : 'outline-primary'}
          onClick={(event) =>
            this.props.hasNext
              ? this.nextClicked(event)
              : this.nextPageClicked()
          }
        >
          <FontAwesomeIcon fixedWidth icon={faArrowDown} />
          {this.props.hasNext ? '次の文' : '次のページ'}
        </Button>
        <Overlay
          target={this.nextRef.current}
          show={this.state.nextHint === 2}
          rootClose
          onHide={() => this.hideHint('next')}
          placement='top'
        >
          {(props) => (
            <Tooltip id='next-tooltip' {...props}>
              タップして次の文章に進む
            </Tooltip>
          )}
        </Overlay>

        {this.props.completed && (
          <span>
            <Button
              ref={this.exitRef}
              onClick={(event) => this.exitClicked(event)}
            >
              <FontAwesomeIcon fixedWidth icon={faCheck} />
              終了
            </Button>
            <Overlay
              target={this.exitRef.current}
              show={this.state.exitHint === 2}
              rootClose
              onHide={() => this.hideHint('exit')}
              placement='top'
            >
              {(props) => (
                <Tooltip id='exit-tooltip' {...props}>
                  タップしてCloze Testを終了できます
                </Tooltip>
              )}
            </Overlay>
          </span>
        )}
      </div>
    )
  }
}

export default NextButtons
